"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("../style/index.css");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _i18n = require("./tools/i18n");

var _reactI18next = require("react-i18next");

var _WatchComponent = _interopRequireDefault(require("./WatchComponent"));

var _reactComponents = require("@cimpress/react-components");

var _IconAlertTriangle = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconAlertTriangle"));

var _IconViewOff = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconViewOff"));

var _IconView = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconView"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Spinner = _reactComponents.shapes.Spinner;

var WatchIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WatchIcon, _React$Component);

  function WatchIcon(props) {
    _classCallCheck(this, WatchIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(WatchIcon).call(this, props));
  }

  _createClass(WatchIcon, [{
    key: "renderOnError",
    value: function renderOnError() {
      return _react.default.createElement("span", {
        className: "watch-icon watch-icon-error"
      }, _react.default.createElement(_reactComponents.Tooltip, {
        direction: 'top',
        contents: this.props.tooltipErrorOverride || this.tt('errors:unable_to_get_subscription_status')
      }, _react.default.createElement(_IconAlertTriangle.default, {
        color: _reactComponents.colors.danger.darkest
      })));
    }
  }, {
    key: "renderOnRunning",
    value: function renderOnRunning() {
      return _react.default.createElement("span", {
        className: "watch-icon watch-icon-loading"
      }, _react.default.createElement(Spinner, {
        size: 24
      }));
    }
  }, {
    key: "renderDefault",
    value: function renderDefault(subscriptionIsActive) {
      var _this = this;

      var Icon = subscriptionIsActive ? _IconView.default : _IconViewOff.default;
      var buttonClass = subscriptionIsActive ? 'watch-icon-subscribed' : 'watch-icon-unsubscribed';
      var tooltip = subscriptionIsActive ? 'click_to_unsubscribe' : 'click_to_subscribe';
      var tooltipOverride = subscriptionIsActive ? this.props.tooltipUnsubscribeOverride : this.props.tooltipSubscribeOverride;
      return _react.default.createElement(_reactComponents.Tooltip, {
        direction: this.props.toolTipDirection,
        contents: tooltipOverride || this.tt(tooltip)
      }, _react.default.createElement("span", {
        className: "watch-icon watch-icon-clickable ".concat(buttonClass),
        onClick: function onClick() {
          return _this.toggleWatchClick(_this.props.resourceUri);
        }
      }, _react.default.createElement(Icon, {
        size: this.props.size
      })));
    }
  }, {
    key: "tt",
    value: function tt(key) {
      // eslint-disable-next-line react/prop-types
      var _this$props = this.props,
          t = _this$props.t,
          locale = _this$props.locale;
      return t(key, {
        lng: locale
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_WatchComponent.default, {
        locale: this.props.locale,
        accessToken: this.props.accessToken,
        resourceUri: this.props.resourceUri,
        refreshInterval: this.props.refreshInterval,
        renderOnError: this.renderOnError.bind(this),
        renderOnRunning: this.renderOnRunning.bind(this),
        renderDefault: this.renderDefault.bind(this)
      });
    }
  }]);

  return WatchIcon;
}(_react.default.Component);

WatchIcon.propTypes = {
  locale: _propTypes.default.string,
  accessToken: _propTypes.default.string.isRequired,
  resourceUri: _propTypes.default.string.isRequired,
  size: _propTypes.default.string,
  refreshInterval: _propTypes.default.number,
  toolTipDirection: _propTypes.default.string,
  tooltipSubscribeOverride: _propTypes.default.string,
  tooltipUnsubscribeOverride: _propTypes.default.string,
  tooltipErrorOverride: _propTypes.default.string
};
WatchIcon.defaultProps = {
  refreshInterval: 60,
  locale: 'en',
  toolTipDirection: 'left',
  size: '2x'
};

var _default = (0, _reactI18next.translate)('watch_icon', {
  i18n: (0, _i18n.getI18nInstance)()
})(WatchIcon);

exports.default = _default;